import { cn } from '@/components/ui/utils';
import { ApiUtils } from '../lib/utils/api';
import { Config } from '@/config';

export default function AppError({ error, className = '' }: { className?: string; error: any }) {
  if (!error) return <></>;

  return (
    <div className={cn('flex w-full rounded-md bg-muted p-4', className)}>
      <div className="flex-shrink-0">
        <svg
          className="h-5 w-5 text-destructive"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="ml-3">
        <h3 className="text-sm font-medium text-foreground">{ApiUtils.convertApiErrorToString(error)}</h3>
        {Config.environment !== 'production' && (
          <p className="text-xs whitespace-pre-wrap [word-break:break-all] mt-1">{error?.stack}</p>
        )}
        {Config.environment !== 'production' && error?.message === 'Failed to fetch' && (
          <p className="text-sm font-medium mt-1 text-destructive">Dev note: Make sure the API is running</p>
        )}
      </div>
    </div>
  );
}
